// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type AddressDetails = {
    address?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    latitude?: number;
    longitude?: number;
    streetNumber?: string;
    timeZone?: string;
    zipCode?: string;
};

export type AdminAccessInputCustomer = {
    accessLevel?: 'OWNER' | 'ADMIN' | 'NONE';
    /**
     * Unique ID
     */
    id?: string;
};

export type AdminAccessInputGroup = {
    accessLevel?: 'OWNER' | 'ADMIN' | 'NONE';
    /**
     * Unique ID
     */
    id?: string;
};

export type AdminAuthData = {
    /**
     * Admin email
     */
    email?: string;
    /**
     * Admin password
     */
    password?: string;
};

export type AdminInviteInput = {
    chargeSystems?: Array<AdminAccessInputGroup>;
    email?: string;
    organizations?: Array<AdminAccessInputCustomer>;
};

export type AdminPasswordData = {
    newPassword?: string;
    password?: string;
};

export type AlterRfidInput = {
    chargeSystems?: Array<string>;
    connectors?: Array<string>;
    groups?: Array<string>;
};

export type AnonymousSetupAcceptInviteRequestEmail = {
    /**
     * The countryCode received when setting up the charge system setup
     */
    countryCode: string;
    /**
     * Email to the admin of the charge system
     */
    email: string;
    /**
     * The timeZone received when setting up the charge system setup
     */
    timeZone?: string;
    /**
     * The token received when setting up the charge system setup
     */
    token: string;
    validationErrors?: AnonymousSetupResponse;
};

export type AnonymousSetupAcceptInviteRequestPhone = {
    /**
     * The countryCode received when setting up the charge system setup
     */
    countryCode: string;
    /**
     * Email to the admin of the charge system
     */
    phoneNumber: string;
    /**
     * The timeZone received when setting up the charge system setup
     */
    timeZone?: string;
    /**
     * The token received when setting up the charge system setup
     */
    token: string;
    validationErrors?: AnonymousSetupResponse;
};

export type AnonymousSetupResponse = {
    status?: AnonymousSetupResponseStatus;
};

export enum AnonymousSetupResponseStatus {
    ALREADY_ACCEPTED_INVITE = 'ALREADY_ACCEPTED_INVITE',
    INVALID_BRAND = 'INVALID_BRAND',
    COUNTRY_NOT_FOUND = 'COUNTRY_NOT_FOUND',
    TOKEN_CREATION_FAILED = 'TOKEN_CREATION_FAILED',
    INVALID_CHARGEPOINT_ID = 'INVALID_CHARGEPOINT_ID',
    INVALID_CLU_LIST_CLU_NOT_IN_CS_SYSTEM = 'INVALID_CLU_LIST_CLU_NOT_IN_CS_SYSTEM',
    EXISTING_CHARGERS_NO_COUNTRY_FOR_SAME_CS = 'EXISTING_CHARGERS_NO_COUNTRY_FOR_SAME_CS',
    EXISTING_CHARGERS_NOT_IN_SAME_CS = 'EXISTING_CHARGERS_NOT_IN_SAME_CS',
    ONLY_EXISTING_CHARGERS = 'ONLY_EXISTING_CHARGERS',
    EMPTY_CONNECTORS = 'EMPTY_CONNECTORS',
    INVALID_CONNECTOR_ID_SEQUENCE = 'INVALID_CONNECTOR_ID_SEQUENCE',
    DUPLICATE_CONNECTOR_ALIAS = 'DUPLICATE_CONNECTOR_ALIAS',
    NOT_P3_FACILITY = 'NOT_P3_FACILITY',
    TOKEN_NOT_VALID = 'TOKEN_NOT_VALID',
    REQUEST_FIELDS_NOT_VALID = 'REQUEST_FIELDS_NOT_VALID',
    EMAIL_NOT_VALID = 'EMAIL_NOT_VALID',
    PHONE_NOT_VALID = 'PHONE_NOT_VALID',
    SUCCESS = 'SUCCESS'
}

export type ApiAdminInvite = {
    email?: string;
    expirationDate?: string;
};

export type ApiAdminUpdateRequest = {
    acceptedPrivacyConditions?: boolean;
    acceptedTermsAndConditions?: boolean;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
};

export type ApiChargeSystem = {
    P3liveConsumptionEnabled?: boolean;
    addressDetails?: AddressDetails;
    category?: string;
    configurationStatus?: string;
    connectors?: Array<string>;
    extApiClientP3?: string;
    groups?: Array<string>;
    id?: string;
    invoicingInfo?: InvoicingInfo;
    name?: string;
    subCategory?: string;
    users?: Array<string>;
    version?: number;
};

export type ApiOutputAdmin = {
    acceptedPrivacyConditions?: boolean;
    acceptedTermsAndConditions?: boolean;
    acceptedTime?: string;
    addCpAdmin?: boolean;
    adminInfo?: string;
    authAlias?: string;
    childAdmin?: boolean;
    createdBy?: string;
    customer?: string;
    email?: string;
    firstName?: string;
    fullUi?: boolean;
    god?: boolean;
    groups?: Array<string>;
    id?: string;
    lastName?: string;
    modAdmin?: boolean;
    phoneNumber?: string;
    superAdmin?: boolean;
};

/**
 * Automatic report configuration
 */
export type AutomaticReportConfigDto = {
    /**
     * Charge system IDs to include in report
     */
    chargeSystemIds: Array<string>;
    /**
     * Email recipients for the report. Use comma separation for multiple recipients
     */
    emailRecipients: Array<string>;
    /**
     * Custom email subject
     */
    emailSubject?: string | null;
    /**
     * Whether the report is enabled
     */
    enabled: boolean;
    /**
     * Output file format: (options: csv, txt)
     */
    fileFormat: string;
    /**
     * Report frequency (options: DAILY, MONTHLY, QUARTERLY)
     */
    frequency: string;
    /**
     * Configuration ID, only present in responses
     */
    id?: string | null;
    /**
     * Report language, use language code
     */
    language: string;
    /**
     * Types of reports to generate: (options: payout, imd, session, user, rfid, charger)
     */
    reportTypes: Array<string>;
};

export type ChangeAvailabilityReqItem = {
    availability?: 'INOPERATIVE' | 'OPERATIVE';
    connectorId?: string;
};

export type ChargeSystemSetupInfoResponse = {
    addressDetails?: AddressDetails;
    numOfConnectors?: number;
    projectName?: string;
    status?: string;
};

export type Component = {
    connectorId?: number;
    evseId?: number;
    instance?: string;
    name: string;
};

export type ConnectorGraphApiModel = {
    accessControlInSync?: boolean;
    alias?: string;
    broadcast?: boolean;
    /**
     * Unique ID
     */
    chargePointId?: string;
    connectorNumber?: number;
    displayName?: string;
    durationLimit?: number;
    /**
     * Unique ID
     */
    group?: string;
    /**
     * Unique ID
     */
    id?: string;
    idleFee?: number;
    meterValue?: number;
    power?: number;
    privateCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    privateChargingSettings?: PrivateChargingSettings;
    publicCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    publicChargingSettings?: PublicChargingSettings;
    rentalActive?: boolean;
    rentalFee?: number;
    rentalFeeType?: 'HOURS' | 'KWH';
    responseCodes?: Array<'ACCEPTED' | 'REJECTED' | 'FAILURE' | 'UNREACHABLE' | 'REBOOT_REQUIRED' | 'NOT_SUPPORTED' | 'PENDING'>;
    status?: 'AVAILABLE' | 'OCCUPIED' | 'PREPARING' | 'CHARGING' | 'SUSPENDED_EV' | 'SUSPENDED_EVSE' | 'FINISHING' | 'FAULTED' | 'UNAVAILABLE' | 'RESERVED' | 'RESTARTING' | 'FACILITY_FINISHING' | 'IDLE' | 'EV_CONNECTED';
    type?: 'TYPE1' | 'TYPE2_CABLE' | 'TYPE2_SOCKET' | 'TYPE3' | 'CHADEMO' | 'CCS' | 'SHUKO' | 'TESLA_SC' | 'UNKNOWN';
    visibleInApps?: boolean;
};

export type ConnectorStatusView = {
    alias?: string;
    /**
     * Unique ID
     */
    chargePointId?: string;
    /**
     * Unique ID
     */
    connectorId?: string;
    displayName?: string;
    errorCode?: string;
    errorInfo?: string;
    groupDescription?: string;
    /**
     * Unique ID
     */
    groupId?: string;
    status?: 'AVAILABLE' | 'OCCUPIED' | 'PREPARING' | 'CHARGING' | 'SUSPENDED_EV' | 'SUSPENDED_EVSE' | 'FINISHING' | 'FAULTED' | 'UNAVAILABLE' | 'RESERVED' | 'RESTARTING' | 'FACILITY_FINISHING' | 'IDLE' | 'EV_CONNECTED';
    statusUpdated?: string;
};

export type ConsumptionRequest = {
    consumptionEnabled?: boolean;
};

export type CreateRfidInput = {
    chargeSystems?: Array<string>;
    connectors?: Array<string>;
    groups?: Array<string>;
    key?: string;
    name?: string;
};

export type CustomerMetadata = {
    billingAddress?: AddressDetails;
    orgEmail?: string;
    orgName?: string;
};

export type GraphApiModel = {
    broadcast?: boolean;
    ccGoActivated?: boolean;
    connectors?: Array<string>;
    /**
     * Unique ID
     */
    id?: string;
    latitude?: number;
    longitude?: number;
    name?: string;
    privateCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    privateChargingSettings?: PrivateChargingSettings;
    publicCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    publicChargingSettings?: PublicChargingSettings;
    responseCodes?: Array<'ACCEPTED' | 'REJECTED' | 'FAILURE' | 'UNREACHABLE' | 'REBOOT_REQUIRED' | 'NOT_SUPPORTED' | 'PENDING'>;
    visibleInApps?: boolean;
};

export type InvoicingChangeRecord = {
    /**
     * Unique ID
     */
    adminId?: string;
    changeTime?: string;
    invoicingActivated?: boolean;
};

export type InvoicingInfo = {
    /**
     * Unique ID
     */
    adminId?: string;
    changeHistory?: Array<InvoicingChangeRecord>;
    fixedCostPerUser?: number;
    invoicingActivated?: boolean;
    modifiedTime?: string;
};

export type LinearTariff = Omit<Tariff, 'type'> & {
    hourDivisor?: number;
    userToInvoice?: string;
    type: 'LinearTariff';
};

export type ListConnectorStatusesResponse = {
    connectorStatuses?: Array<ConnectorStatusView>;
};

export type Ocpp = {
    chargingState?: 'Charging' | 'EVConnected' | 'SuspendedEV' | 'SuspendedEVSE' | 'Idle' | 'UNRECOGNIZED';
    status?: 'AVAILABLE' | 'OCCUPIED' | 'PREPARING' | 'CHARGING' | 'SUSPENDED_EV' | 'SUSPENDED_EVSE' | 'FINISHING' | 'FAULTED' | 'UNAVAILABLE' | 'RESERVED' | 'RESTARTING' | 'FACILITY_FINISHING' | 'IDLE' | 'EV_CONNECTED';
    version?: 'OCPP15SOAP' | 'OCPP15' | 'OCPP16' | 'OCPP20' | 'TEST';
};

export type P3InvitedUser = {
    chargeSystems: Array<P3UserAccess>;
    connectors: Array<P3UserAccess>;
    expirationDate: string;
    groups: Array<P3UserAccess>;
    phoneNumber: string;
};

/**
 * List of invoices
 */
export type P3Invoice = {
    chargeSystemId: string;
    cost: number;
    createdDate: string;
    currency?: 'AUD' | 'CAD' | 'CHF' | 'CZK' | 'CNY' | 'DKK' | 'EUR' | 'GBP' | 'HUF' | 'HRK' | 'ILS' | 'ISK' | 'MTL' | 'NOK' | 'NZD' | 'PLN' | 'RON' | 'ROL' | 'SEK' | 'SIT' | 'SKK' | 'USD' | 'XOF';
    /**
     * Null if status is Deferred
     */
    dueDate?: string;
    email: string;
    invoiceId: string;
    /**
     * Null if status is Deferred
     */
    invoiceNumber?: string;
    name: string;
    status: string;
    totalKwh: number;
};

/**
 * Details of an invoice
 */
export type P3InvoiceDetails = {
    currency?: 'AUD' | 'CAD' | 'CHF' | 'CZK' | 'CNY' | 'DKK' | 'EUR' | 'GBP' | 'HUF' | 'HRK' | 'ILS' | 'ISK' | 'MTL' | 'NOK' | 'NZD' | 'PLN' | 'RON' | 'ROL' | 'SEK' | 'SIT' | 'SKK' | 'USD' | 'XOF';
    customerMetadata: CustomerMetadata;
    /**
     * Null if status is Deferred
     */
    dueDate?: string;
    fee: number;
    invoiceId: string;
    /**
     * Null if status is Deferred
     */
    invoiceNumber?: string;
    lineItems: Array<P3InvoiceLineItem>;
    /**
     * Null if status is Deferred
     */
    pdfDownloadUrl?: string;
    platformFeePercentage: number;
    platformFees: number;
    sessionTotal: number;
    status: string;
    totalCost: number;
    userMetadata: UserMetadata;
    vatAmount: number;
    vatPercentage: number;
};

export type P3InvoiceLineItem = {
    chargePoint: string;
    chargedKwh: number;
    cost: number;
    duration: number;
    sessionId: string;
    startTime: string;
    stopTime: string;
    tariff: Tariff;
};

/**
 * Page of invoices
 */
export type P3InvoicePage = {
    /**
     * List of invoices
     */
    invoices: Array<P3Invoice>;
    /**
     * Pagination token
     */
    paginationToken?: string;
    /**
     * Total items
     */
    totalItems: number;
};

/**
 * Outstanding invoice amounts
 */
export type P3InvoicesOutstandingAmounts = {
    currency?: 'AUD' | 'CAD' | 'CHF' | 'CZK' | 'CNY' | 'DKK' | 'EUR' | 'GBP' | 'HUF' | 'HRK' | 'ILS' | 'ISK' | 'MTL' | 'NOK' | 'NZD' | 'PLN' | 'RON' | 'ROL' | 'SEK' | 'SIT' | 'SKK' | 'USD' | 'XOF';
    /**
     * Total outstanding amount for deferred invoices
     */
    deferred: number;
    /**
     * Total outstanding amount for open invoices
     */
    open: number;
    /**
     * Total outstanding amount for overdue invoices
     */
    overdue: number;
};

export type P3User = {
    activeGroupInvoice: boolean;
    chargeSystems: Array<P3UserAccess>;
    connectors: Array<P3UserAccess>;
    discount: number;
    groups: Array<P3UserAccess>;
    /**
     * Unique ID
     */
    id: string;
    lastName?: string;
    name?: string;
    phoneNumber: string;
};

export type P3UserAccess = {
    accessLevel: 'USER' | 'OWNER';
    /**
     * Unique ID
     */
    id: string;
    name: string;
};

export type PrimeApiConnector = {
    accessControlInSync?: boolean;
    alias?: string;
    broadcast?: boolean;
    chargePointId?: string;
    connectorNumber?: number;
    displayName?: string;
    durationLimit?: number;
    energyMeterAvailable?: 'PRESENT' | 'ABSENT' | 'UNKNOWN';
    errorCode?: string;
    errorInfo?: string;
    group?: string;
    id?: string;
    idleFee?: number;
    meterValue?: number;
    operationalData?: PrimeApiConnectorOperationalData;
    power?: number;
    privateCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    privateChargingSettings?: PrivateChargingSettings;
    publicCharging?: 'DISABLED' | 'ENABLED' | 'SETUP_REQUIRED';
    publicChargingSettings?: PublicChargingSettings;
    rentalActive?: boolean;
    rentalFee?: number;
    rentalFeeType?: 'HOURS' | 'KWH';
    sim?: boolean;
    status?: 'AVAILABLE' | 'OCCUPIED' | 'PREPARING' | 'CHARGING' | 'SUSPENDED_EV' | 'SUSPENDED_EVSE' | 'FINISHING' | 'FAULTED' | 'UNAVAILABLE' | 'RESERVED' | 'RESTARTING' | 'FACILITY_FINISHING' | 'IDLE' | 'EV_CONNECTED';
    type?: 'TYPE1' | 'TYPE2_CABLE' | 'TYPE2_SOCKET' | 'TYPE3' | 'CHADEMO' | 'CCS' | 'SHUKO' | 'TESLA_SC' | 'UNKNOWN';
    visibleInApps?: boolean;
};

export type PrimeApiConnectorOperationalData = {
    errorCode?: string;
    hbLastAlive?: string;
    hbTimeout?: boolean;
    info?: string;
    ocpp?: Ocpp;
    transactionMeterValue?: number;
    websocketOffline?: boolean;
    websocketOfflineStatusLastChanged?: string;
};

export type PrivateChargingSettings = {
    accountNumber?: string;
    billingInterval?: 'DAILY' | 'MONTHLY' | 'QUARTERLY' | 'SEMI_YEARLY' | 'YEARLY';
    billingMethod?: 'CARD' | 'INVOICE' | 'FREE' | 'IMD';
    priceModel?: 'FLAT_RATE' | 'POWER_USAGE' | 'TIME_USAGE' | 'FREE';
    priceModelAmount?: string;
    tariff?: Tariff;
};

export type ProgressiveTariff = Omit<Tariff, 'type'> & {
    hourDivisor?: number;
    nrOfMinutes?: number;
    pricePerHour2?: number;
    type: 'ProgressiveTariff';
};

export type PublicChargingSettings = {
    accountNumber?: string;
    durationLimit?: number;
    idleFee?: number;
    priceModel?: 'FLAT_RATE' | 'POWER_USAGE' | 'TIME_USAGE' | 'FREE';
    priceModelAmount?: string;
    schema?: Array<PublicChargingTime>;
    tariff?: Tariff;
};

export type PublicChargingTime = {
    day?: string;
    from?: string;
    isAllDay?: boolean;
    to?: string;
};

export type ResetTypeContainer = {
    type?: 'HARD' | 'SOFT';
};

export type SafeAlertGroupMember = {
    availability?: 'ALWAYS' | 'OFFICEHRS' | 'UNAVAILABLE';
    email?: string;
    filterMap?: {
        [key: string]: string;
    };
    name?: string;
    phone?: string;
    sendSms?: boolean;
};

export type SetChargeSystemImdRequest = {
    imdCostInKwh: number;
    useImd: boolean;
};

export type SetChargeSystemImdUserInvoiceReferenceRequest = {
    invoiceReference: string;
};

export type SetChargeSystemInvoicingRequest = {
    fixedPerUserFee: number;
    useInvoicing: boolean;
};

export type SetDiscountRequest = {
    discount?: number;
    /**
     * Unique ID
     */
    userId?: string;
};

export type SetDisplayMessageRequest = {
    /**
     * Unique ID
     */
    chargepointId?: string;
    component?: Component;
    content: string;
    end?: number;
    format: 'ASCII' | 'HTML' | 'URI' | 'UTF8';
    id: number;
    language?: string;
    priority: 'ALWAYS_FRONT' | 'IN_FRONT' | 'NORMAL_CYCLE';
    start?: number;
    state?: 'CHARGING' | 'FAULTED' | 'IDLE' | 'UNAVAILABLE';
    transId?: string;
};

export type SetUserInvoicingRequest = {
    useInvoicing: boolean;
    userId: string;
};

export type Tariff = {
    fixedCost?: number;
    free?: boolean;
    freeParking?: boolean;
    pricePerHour?: number;
    pricePerKwh?: number;
    type: string;
};

export type TimezonedTariff = Omit<Tariff, 'type'> & {
    hourDivisor?: number;
    pricePerHourZone?: number;
    pricePerKwhZone?: number;
    zoneHrEnd?: number;
    zoneHrStart?: number;
    type: 'TimezonedTariff';
};

export type UserAccessInputConnector = {
    accessLevel?: 'OWNER' | 'USER' | 'OWNER_INVITED' | 'USER_INVITED';
    /**
     * Unique ID
     */
    id?: string;
};

export type UserAccessInputConnectorGroup = {
    accessLevel?: 'OWNER' | 'USER' | 'OWNER_INVITED' | 'USER_INVITED';
    /**
     * Unique ID
     */
    id?: string;
};

export type UserAccessInputGroup = {
    accessLevel?: 'OWNER' | 'USER' | 'OWNER_INVITED' | 'USER_INVITED';
    /**
     * Unique ID
     */
    id?: string;
};

export type UserAlterAccessInput = {
    chargeSystems?: Array<UserAccessInputGroup>;
    connectors?: Array<UserAccessInputConnector>;
    groups?: Array<UserAccessInputConnectorGroup>;
    id?: string;
};

export type UserInviteInput = {
    begin?: string;
    chargeSystems?: Array<UserAccessInputGroup>;
    connectors?: Array<UserAccessInputConnector>;
    end?: string;
    groups?: Array<UserAccessInputConnectorGroup>;
    phoneNumber?: string;
    phoneNumberCountryCode?: 'AT' | 'AU' | 'AX' | 'BE' | 'BG' | 'CA' | 'CH' | 'CY' | 'CZ' | 'CN' | 'DE' | 'DK' | 'EE' | 'ES' | 'FI' | 'FO' | 'FR' | 'GB' | 'GL' | 'GR' | 'HR' | 'HU' | 'IE' | 'IL' | 'IS' | 'IT' | 'LT' | 'LV' | 'LU' | 'MT' | 'NL' | 'NO' | 'NZ' | 'PL' | 'PT' | 'RO' | 'SE' | 'SI' | 'SK' | 'US';
};

export type UserMetadata = {
    email?: string;
    name?: string;
    phoneNumber?: string;
};

export type VisitorRfidKeyInput = {
    name?: string;
};

export type RemoveAdminAccessData = {
    body?: Array<AdminInviteInput>;
    path?: never;
    query?: never;
    url: '/admin';
};

export type RemoveAdminAccessResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetLoggedInAdminData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/admin';
};

export type GetLoggedInAdminErrors = {
    /**
     * admin not found in database
     */
    404: unknown;
};

export type GetLoggedInAdminResponses = {
    200: ApiOutputAdmin;
};

export type GetLoggedInAdminResponse = GetLoggedInAdminResponses[keyof GetLoggedInAdminResponses];

export type UpdateLoggedInAdminData = {
    body?: ApiAdminUpdateRequest;
    path?: never;
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/admin';
};

export type UpdateLoggedInAdminErrors = {
    /**
     * bad request
     */
    400: unknown;
    /**
     * admin not found in database
     */
    404: unknown;
};

export type UpdateLoggedInAdminResponses = {
    200: ApiOutputAdmin;
};

export type UpdateLoggedInAdminResponse = UpdateLoggedInAdminResponses[keyof UpdateLoggedInAdminResponses];

export type ChangeAdminPasswordData = {
    body?: AdminPasswordData;
    path?: never;
    query?: never;
    url: '/admin/password';
};

export type ChangeAdminPasswordResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ListAdminsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/admins';
};

export type ListAdminsErrors = {
    /**
     * admin not found in database
     */
    404: unknown;
};

export type ListAdminsResponses = {
    200: Array<ApiOutputAdmin>;
};

export type ListAdminsResponse = ListAdminsResponses[keyof ListAdminsResponses];

export type GetAdminByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/admins/{id}';
};

export type GetAdminByIdErrors = {
    /**
     * admin not found in database
     */
    404: unknown;
};

export type GetAdminByIdResponses = {
    200: ApiOutputAdmin;
};

export type GetAdminByIdResponse = GetAdminByIdResponses[keyof GetAdminByIdResponses];

export type AcceptFacilityChargeSystemSetupData = {
    body: AnonymousSetupAcceptInviteRequestEmail;
    path?: never;
    query?: never;
    url: '/anonymoussetup/facility';
};

export type AcceptFacilityChargeSystemSetupErrors = {
    /**
     * Validation failed or invite token is no longer valid.
     */
    400: AnonymousSetupResponse | AnonymousSetupResponseStatus;
    /**
     * Charge system setup invite acceptance failed.
     */
    500: string | AnonymousSetupResponseStatus;
};

export type AcceptFacilityChargeSystemSetupError = AcceptFacilityChargeSystemSetupErrors[keyof AcceptFacilityChargeSystemSetupErrors];

export type AcceptFacilityChargeSystemSetupResponses = {
    /**
     * Charge system setup invite accepted.
     */
    200: AnonymousSetupResponse;
};

export type AcceptFacilityChargeSystemSetupResponse = AcceptFacilityChargeSystemSetupResponses[keyof AcceptFacilityChargeSystemSetupResponses];

export type AcceptHomeChargeSystemSetupData = {
    body: AnonymousSetupAcceptInviteRequestPhone;
    path?: never;
    query?: never;
    url: '/anonymoussetup/home';
};

export type AcceptHomeChargeSystemSetupErrors = {
    /**
     * Validation failed or invite token is no longer valid.
     */
    400: AnonymousSetupResponse | AnonymousSetupResponseStatus;
    /**
     * Charge system setup invite acceptance failed.
     */
    500: string | AnonymousSetupResponseStatus;
};

export type AcceptHomeChargeSystemSetupError = AcceptHomeChargeSystemSetupErrors[keyof AcceptHomeChargeSystemSetupErrors];

export type AcceptHomeChargeSystemSetupResponses = {
    /**
     * Charge system setup invite accepted.
     */
    200: AnonymousSetupResponse;
};

export type AcceptHomeChargeSystemSetupResponse = AcceptHomeChargeSystemSetupResponses[keyof AcceptHomeChargeSystemSetupResponses];

export type GetChargeSystemSetupInfoData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/anonymoussetup/{token}';
};

export type GetChargeSystemSetupInfoErrors = {
    /**
     * Token validation failed.
     */
    400: AnonymousSetupResponseStatus;
};

export type GetChargeSystemSetupInfoError = GetChargeSystemSetupInfoErrors[keyof GetChargeSystemSetupInfoErrors];

export type GetChargeSystemSetupInfoResponses = {
    /**
     * Charge system setup information.
     */
    200: ChargeSystemSetupInfoResponse;
};

export type GetChargeSystemSetupInfoResponse = GetChargeSystemSetupInfoResponses[keyof GetChargeSystemSetupInfoResponses];

export type CheckAuthenticationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/authenticated';
};

export type CheckAuthenticationResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetChargeSystemAlertGroupsData = {
    body?: never;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/alertgroup';
};

export type GetChargeSystemAlertGroupsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type UpdateChargeSystemAlertGroupData = {
    body?: Array<SafeAlertGroupMember>;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/alertgroup';
};

export type UpdateChargeSystemAlertGroupResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ClearDisplayMessageData = {
    body?: number;
    path: {
        csId: string;
        cpId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/charge-point/{cpId}/display-message';
};

export type ClearDisplayMessageResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetDisplayMessageData = {
    body?: SetDisplayMessageRequest;
    path: {
        csId: string;
        cpId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/charge-point/{cpId}/display-message';
};

export type SetDisplayMessageResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ResetChargePointData = {
    body?: ResetTypeContainer;
    path: {
        csId: string;
        cpId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/charge-point/{cpId}/reset';
};

export type ResetChargePointResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type UpdateChargeSystemConnectorData = {
    body?: ConnectorGraphApiModel;
    path: {
        csId: string;
        cId: string;
    };
    query?: {
        forceConfig?: boolean;
    };
    url: '/charge-system/{csId}/connector/{cId}';
};

export type UpdateChargeSystemConnectorResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type StatusHistoryData = {
    body?: never;
    path: {
        csId: string;
        connector: string;
    };
    query?: never;
    url: '/charge-system/{csId}/connector/{connector}/statusHistory';
};

export type StatusHistoryResponses = {
    /**
     * Success
     */
    200: string;
};

export type StatusHistoryResponse = StatusHistoryResponses[keyof StatusHistoryResponses];

export type GetChargeSystemConnectorsData = {
    body?: never;
    path: {
        csId: string;
    };
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/charge-system/{csId}/connectors';
};

export type GetChargeSystemConnectorsResponses = {
    /**
     * Success
     */
    200: Array<PrimeApiConnector>;
};

export type GetChargeSystemConnectorsResponse = GetChargeSystemConnectorsResponses[keyof GetChargeSystemConnectorsResponses];

export type SetP3LiveConsumptionData = {
    body?: ConsumptionRequest;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/consumption';
};

export type SetP3LiveConsumptionResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetChargeSystemChargersToDefaultData = {
    body?: never;
    path: {
        csId: string;
    };
    query?: {
        forceConfig?: boolean;
    };
    url: '/charge-system/{csId}/default';
};

export type SetChargeSystemChargersToDefaultResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetDiscountForUserData = {
    body?: SetDiscountRequest;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/discount';
};

export type SetDiscountForUserResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetChargeSystemImdData = {
    body?: never;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/imd';
};

export type GetChargeSystemImdResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetChargeSystemImdData = {
    body?: SetChargeSystemImdRequest;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/imd';
};

export type SetChargeSystemImdResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetChargeSystemImdUsersData = {
    body?: never;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/imd/users';
};

export type GetChargeSystemImdUsersResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetChargeSystemImdUserData = {
    body?: SetChargeSystemImdUserInvoiceReferenceRequest;
    path: {
        csId: string;
        userId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/imd/users/{userId}';
};

export type SetChargeSystemImdUserResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetChargeSystemInvoicingData = {
    body?: SetChargeSystemInvoicingRequest;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/invoicing';
};

export type SetChargeSystemInvoicingResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type SetUserInvoicingData = {
    body?: SetUserInvoicingRequest;
    path: {
        csId: string;
    };
    query?: never;
    url: '/charge-system/{csId}/invoicing/user';
};

export type SetUserInvoicingResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type AlterUserAccessData = {
    body?: Array<UserAlterAccessInput>;
    path: {
        id: string;
    };
    query?: never;
    url: '/charge-system/{id}/access';
};

export type AlterUserAccessResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type RevokeUserInviteToChargeSystemData = {
    body?: Array<UserInviteInput>;
    path: {
        id: string;
    };
    query?: never;
    url: '/charge-system/{id}/invite';
};

export type RevokeUserInviteToChargeSystemResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type InviteUserToChargeSystemData = {
    body?: Array<UserInviteInput>;
    path: {
        id: string;
    };
    query?: never;
    url: '/charge-system/{id}/invite';
};

export type InviteUserToChargeSystemResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ResendUserInviteData = {
    body?: Array<UserInviteInput>;
    path: {
        id: string;
    };
    query?: never;
    url: '/charge-system/{id}/resend-invite';
};

export type ResendUserInviteResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type DeleteKeyAccessToChargeSystemData = {
    body?: never;
    path: {
        id: string;
        rfidKey: string;
    };
    query?: never;
    url: '/charge-system/{id}/rfid/{rfidKey}';
};

export type DeleteKeyAccessToChargeSystemResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type DeleteUserAccessToChargeSystemData = {
    body?: never;
    path: {
        id: string;
        phoneNumber: string;
    };
    query?: never;
    url: '/charge-system/{id}/user/{phoneNumber}';
};

export type DeleteUserAccessToChargeSystemResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ListChargeSystemsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/charge-systems';
};

export type ListChargeSystemsResponses = {
    /**
     * Success
     */
    200: Array<ApiChargeSystem>;
};

export type ListChargeSystemsResponse = ListChargeSystemsResponses[keyof ListChargeSystemsResponses];

export type StartChargingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/charger/{id}/start';
};

export type StartChargingResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type StopChargingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/charger/{id}/stop';
};

export type StopChargingResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type RevokeAdminInviteData = {
    body?: Array<AdminInviteInput>;
    path?: never;
    query?: never;
    url: '/invite-admins';
};

export type RevokeAdminInviteResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type InviteAdminsData = {
    body?: Array<AdminInviteInput>;
    path?: never;
    query?: never;
    url: '/invite-admins';
};

export type InviteAdminsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetP3InvitedUsersData = {
    body?: never;
    path?: never;
    query?: {
        csId?: string;
    };
    url: '/invited-users';
};

export type GetP3InvitedUsersErrors = {
    /**
     * Bad request
     */
    400: string;
    /**
     * Forbidden
     */
    403: string;
};

export type GetP3InvitedUsersError = GetP3InvitedUsersErrors[keyof GetP3InvitedUsersErrors];

export type GetP3InvitedUsersResponses = {
    /**
     * Successfully return invited app users
     */
    200: Array<P3InvitedUser>;
};

export type GetP3InvitedUsersResponse = GetP3InvitedUsersResponses[keyof GetP3InvitedUsersResponses];

export type GetInvoicesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Charge System
         */
        csId?: string;
        /**
         * Filter by user
         */
        userId?: string;
        /**
         * Status of the invoices
         */
        status?: 'DEFERRED' | 'OPEN' | 'PAID' | 'OVERDUE';
        /**
         * Number of invoices to fetch
         */
        limit?: number;
        /**
         * Sort order
         */
        sortAscending?: boolean;
        /**
         * Pagination token
         */
        paginationToken?: string;
    };
    url: '/invoices';
};

export type GetInvoicesResponses = {
    /**
     * Success
     */
    200: Array<P3InvoicePage>;
};

export type GetInvoicesResponse = GetInvoicesResponses[keyof GetInvoicesResponses];

export type GetInvoicesOutstandingAmountsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Charge System
         */
        csId?: string;
    };
    url: '/invoices/outstanding-amounts';
};

export type GetInvoicesOutstandingAmountsResponses = {
    /**
     * Success
     */
    200: P3InvoicesOutstandingAmounts;
};

export type GetInvoicesOutstandingAmountsResponse = GetInvoicesOutstandingAmountsResponses[keyof GetInvoicesOutstandingAmountsResponses];

export type GetInvoiceData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: {
        /**
         * Charge System
         */
        csId?: string;
    };
    url: '/invoices/{invoiceId}';
};

export type GetInvoiceResponses = {
    /**
     * Success
     */
    200: P3InvoiceDetails;
};

export type GetInvoiceResponse = GetInvoiceResponses[keyof GetInvoiceResponses];

export type CheckInviteData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/isinvitevalid/token/{token}';
};

export type CheckInviteResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type ListConnectorStatusesData = {
    body?: never;
    path?: never;
    query?: {
        customerId?: string;
    };
    url: '/list-connector-statuses';
};

export type ListConnectorStatusesResponses = {
    /**
     * Success
     */
    200: ListConnectorStatusesResponse;
};

export type ListConnectorStatusesResponse2 = ListConnectorStatusesResponses[keyof ListConnectorStatusesResponses];

export type LoginData = {
    body?: AdminAuthData;
    path?: never;
    query?: never;
    url: '/login';
};

export type LoginResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetOrganizationAdminsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/organization/{id}/admins';
};

export type GetOrganizationAdminsErrors = {
    /**
     * organization not found or inaccessible
     */
    404: unknown;
};

export type GetOrganizationAdminsResponses = {
    200: Array<ApiOutputAdmin>;
};

export type GetOrganizationAdminsResponse = GetOrganizationAdminsResponses[keyof GetOrganizationAdminsResponses];

export type GetOrganizationInvitedAdminsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Comma-separated response fields to include
         */
        fields?: string;
    };
    url: '/organization/{id}/admins/invitations';
};

export type GetOrganizationInvitedAdminsErrors = {
    /**
     * organization not found or inaccessible
     */
    404: unknown;
};

export type GetOrganizationInvitedAdminsResponses = {
    200: Array<ApiAdminInvite>;
};

export type GetOrganizationInvitedAdminsResponse = GetOrganizationInvitedAdminsResponses[keyof GetOrganizationInvitedAdminsResponses];

export type ChangeAvailabilityForConnectorsData = {
    body?: Array<ChangeAvailabilityReqItem>;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/organization/{orgId}/changeAvailability';
};

export type ChangeAvailabilityForConnectorsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetReportData = {
    body?: never;
    path: {
        orgId: string;
    };
    query?: {
        reportType?: 'payout' | 'imd' | 'session' | 'user' | 'rfid' | 'charger';
        startDate?: string;
        endDate?: string;
        chargeSystemId?: Array<string>;
        language?: 'en' | 'sv' | 'no' | 'fi';
        fileFormat?: 'csv' | 'excel' | 'txt';
    };
    url: '/organization/{orgId}/report';
};

export type GetReportResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type CreateRfidData = {
    body?: CreateRfidInput;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/organization/{orgId}/rfid';
};

export type CreateRfidResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type DeleteRfidData = {
    body?: never;
    path: {
        orgId: string;
        userId: string;
    };
    query?: never;
    url: '/organization/{orgId}/rfid/{userId}';
};

export type DeleteRfidResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type AlterRfidAccessData = {
    body?: AlterRfidInput;
    path: {
        orgId: string;
        userId: string;
    };
    query?: never;
    url: '/organization/{orgId}/rfid/{userId}';
};

export type AlterRfidAccessResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetAutomaticReportsData = {
    body?: never;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/organization/{orgId}/settings/automatic-reports';
};

export type GetAutomaticReportsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type CreateAutomaticReportData = {
    body?: AutomaticReportConfigDto;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/organization/{orgId}/settings/automatic-reports';
};

export type CreateAutomaticReportResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type DeleteAutomaticReportData = {
    body?: never;
    path: {
        orgId: string;
        reportId: string;
    };
    query?: never;
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}';
};

export type DeleteAutomaticReportResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetAutomaticReportData = {
    body?: never;
    path: {
        orgId: string;
        reportId: string;
    };
    query?: never;
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}';
};

export type GetAutomaticReportResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type UpdateAutomaticReportData = {
    body?: AutomaticReportConfigDto;
    path: {
        orgId: string;
        reportId: string;
    };
    query?: never;
    url: '/organization/{orgId}/settings/automatic-reports/{reportId}';
};

export type UpdateAutomaticReportResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type UpdateConnectorGroupsData = {
    body?: Array<GraphApiModel>;
    path: {
        organizationId: string;
        chargeSystemId: string;
    };
    query?: {
        forceConfig?: boolean;
    };
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups';
};

export type UpdateConnectorGroupsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type CreateConnectorGroupData = {
    body?: GraphApiModel;
    path: {
        organizationId: string;
        chargeSystemId: string;
    };
    query?: {
        forceConfig?: boolean;
    };
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups';
};

export type CreateConnectorGroupResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type DeleteConnectorGroupData = {
    body?: never;
    path: {
        organizationId: string;
        chargeSystemId: string;
        connectorGroupId: string;
    };
    query?: never;
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups/{connectorGroupId}';
};

export type DeleteConnectorGroupResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type UpdateConnectorGroupData = {
    body?: GraphApiModel;
    path: {
        organizationId: string;
        chargeSystemId: string;
        connectorGroupId: string;
    };
    query?: {
        forceConfig?: boolean;
    };
    url: '/organizations/{organizationId}/charge-systems/{chargeSystemId}/connector-groups/{connectorGroupId}';
};

export type UpdateConnectorGroupResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type StartPingChargerData = {
    body?: never;
    path?: never;
    query?: {
        connectorId?: string;
    };
    url: '/ping/start';
};

export type StartPingChargerResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type StopPingChargerData = {
    body?: never;
    path?: never;
    query?: {
        connectorId?: string;
    };
    url: '/ping/stop';
};

export type StopPingChargerResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetReportsData = {
    body?: never;
    path?: never;
    query?: {
        startDate?: string;
        endDate?: string;
        chargeSystemIds?: Array<string>;
    };
    url: '/report/chargesystems';
};

export type GetReportsResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetPassTokenValidData = {
    body?: never;
    path: {
        passwordToken: string;
        id: string;
    };
    query?: never;
    url: '/resetpassword/isvalidtoken/{id}/{passwordToken}';
};

export type GetPassTokenValidResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type PassWordResetData = {
    body?: string;
    path: {
        passwordToken: string;
        id: string;
    };
    query?: never;
    url: '/resetpassword/newpassword/{id}/{passwordToken}';
};

export type PassWordResetResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type CreateTokenData = {
    body?: never;
    path: {
        email: string;
    };
    query?: {
        disable?: boolean;
    };
    url: '/resetpassword/{email}';
};

export type CreateTokenResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetRfidUsersData = {
    body?: never;
    path?: never;
    query?: {
        orgId?: string;
        csId?: string;
    };
    url: '/rfid-keys';
};

export type GetRfidUsersResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type EditRfidKeyNameData = {
    body?: VisitorRfidKeyInput;
    path: {
        userId: string;
    };
    query?: never;
    url: '/rfid-keys/{userId}';
};

export type EditRfidKeyNameResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type AcceptAdminsToChargeSystemData = {
    body?: AdminAuthData;
    path: {
        token: string;
    };
    query?: never;
    url: '/token/{token}/accept';
};

export type AcceptAdminsToChargeSystemResponses = {
    /**
     * default response
     */
    default: unknown;
};

export type GetP3UsersData = {
    body?: never;
    path?: never;
    query?: {
        csId?: string;
    };
    url: '/users';
};

export type GetP3UsersErrors = {
    /**
     * Bad request
     */
    400: string;
    /**
     * Forbidden
     */
    403: string;
};

export type GetP3UsersError = GetP3UsersErrors[keyof GetP3UsersErrors];

export type GetP3UsersResponses = {
    /**
     * Successfully return app users
     */
    200: Array<P3User>;
};

export type GetP3UsersResponse = GetP3UsersResponses[keyof GetP3UsersResponses];

export type GetP3UserData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        csId?: string;
    };
    url: '/users/{id}';
};

export type GetP3UserErrors = {
    /**
     * Bad request
     */
    400: string;
    /**
     * Forbidden
     */
    403: string;
    /**
     * Not found
     */
    404: string;
};

export type GetP3UserError = GetP3UserErrors[keyof GetP3UserErrors];

export type GetP3UserResponses = {
    /**
     * Successfully return app user
     */
    200: P3User;
};

export type GetP3UserResponse = GetP3UserResponses[keyof GetP3UserResponses];

export type GetVariablesData = {
    body?: never;
    path: {
        cpId: string;
        parameter: string;
    };
    query?: never;
    url: '/variables/{cpId}/{parameter}';
};

export type GetVariablesResponses = {
    /**
     * default response
     */
    default: unknown;
};
